import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { head } from "es-toolkit/array";
import { useCallback } from "react";
import { useSnapshot } from "valtio";
import { FlowActions, FlowState } from "../../stores/flowStore";
export const useCardCheckout = () => {
  const $ = _c(4);
  const {
    flow,
    itemQuotes
  } = useSnapshot(FlowState);
  const checkoutFlow = flow?.type === "checkout" ? flow : undefined;
  const {
    getChain
  } = useChains();
  let t0;
  if ($[0] !== checkoutFlow || $[1] !== getChain || $[2] !== itemQuotes) {
    t0 = () => {
      const itemQuote = head(itemQuotes);
      if (checkoutFlow && itemQuote && itemQuote.orderId) {
        FlowActions.startFlow({
          type: "fiat-checkout",
          item: {
            contractAddress: itemQuote.item.contractAddress,
            tokenId: itemQuote.item.tokenId,
            chain: {
              identifier: itemQuote.item.chain
            },
            quantity: itemQuote.quantity
          },
          listingId: itemQuote.orderId,
          onBack: () => FlowActions.startFlow({
            ...checkoutFlow,
            paymentMethod: "card"
          }),
          onTransactionCreated: tx => {
            const chain = getChain(tx.chain);
            if (chain) {
              FlowActions.startFlow({
                ...checkoutFlow,
                paymentMethod: "card",
                transactionIdentifier: tx
              });
              FlowActions.addReceiptTransaction({
                hash: tx.transactionHash,
                chain: itemQuote.item.chain
              });
              FlowActions.setAllActionsCompleted();
            }
          }
        });
        return;
      }
    };
    $[0] = checkoutFlow;
    $[1] = getChain;
    $[2] = itemQuotes;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};